/**
 * Cascade Filters - Filtri dinamici Marca/Modello
 * Filtra le opzioni del filtro Modello in base alla Marca selezionata
 */

class CascadeFilters {
  constructor() {
    this.brandModelMapping = null;
    this.initialized = false;
    this.init();
  }

  async init() {
    // Carica la mappatura marca-modello
    await this.loadBrandModelMapping();

    // Inizializza i filtri
    this.setupFilters();

    // Listener per cambiamenti nei filtri
    this.attachListeners();

    this.initialized = true;
    console.log('✓ Cascade Filters inizializzati');
  }

  async loadBrandModelMapping() {
    try {
      // L'URL viene iniettato dal template Liquid nella variabile globale
      if (!window.BRAND_MODEL_MAPPING_URL) {
        console.error('✗ URL del JSON non trovato');
        return;
      }

      const response = await fetch(window.BRAND_MODEL_MAPPING_URL);
      this.brandModelMapping = await response.json();
      console.log('✓ Mappatura marca-modello caricata:', this.brandModelMapping);
    } catch (error) {
      console.error('✗ Errore nel caricamento della mappatura:', error);
    }
  }

  setupFilters() {
    // Controlla quali marche sono selezionate
    const selectedBrands = this.getSelectedBrands();

    console.log('Marche selezionate:', selectedBrands);

    if (selectedBrands.length > 0) {
      // Se c'è almeno una marca selezionata, filtra i modelli
      this.filterModels(selectedBrands);
    } else {
      // Nessuna marca selezionata, mostra tutti i modelli
      this.showAllModels();
    }
  }

  getSelectedBrands() {
    const brands = [];

    // 1. Cerca checkbox selezionati (filtri collezione)
    const checkboxes = document.querySelectorAll('input[type="checkbox"][data-filter*="filter_marca"]:checked');
    checkboxes.forEach(checkbox => {
      const value = checkbox.value.toLowerCase().trim();
      if (value) {
        brands.push(value);
      }
    });

    // 2. Cerca elementi <li> con classe selected/active (filtri home)
    const selectedItems = document.querySelectorAll('.filter-select__item.selected[data-filter*="filter_marca"], .filter-select__item.active[data-filter*="filter_marca"]');
    selectedItems.forEach(item => {
      const dataFilter = item.getAttribute('data-filter');
      if (dataFilter) {
        const match = dataFilter.match(/filter_marca=([^&]+)/);
        if (match) {
          brands.push(decodeURIComponent(match[1]).toLowerCase().trim());
        }
      }
    });

    return [...new Set(brands)]; // Rimuovi duplicati
  }

  filterModels(selectedBrands) {
    if (!this.brandModelMapping) return;

    // Ottieni tutti i modelli compatibili con le marche selezionate
    const compatibleModels = new Set();

    selectedBrands.forEach(brand => {
      const brandKey = brand.toLowerCase();
      if (this.brandModelMapping[brandKey]) {
        this.brandModelMapping[brandKey].forEach(model => {
          compatibleModels.add(model.toLowerCase());
        });
      }
    });

    console.log('Modelli compatibili:', Array.from(compatibleModels));

    let hidden = 0;
    let shown = 0;

    // 1. Filtra checkbox modello (filtri collezione)
    const modelCheckboxes = document.querySelectorAll('input[type="checkbox"][data-filter*="filtro_modello"]');
    console.log(`🔍 Trovati ${modelCheckboxes.length} checkbox modello`);

    modelCheckboxes.forEach((checkbox, index) => {
      const originalValue = checkbox.value;
      const modelValue = originalValue.toLowerCase().trim();
      const listItem = checkbox.closest('li');

      if (!listItem) return;

      const isCompatible = compatibleModels.has(modelValue);

      if (index < 3) {
        console.log(`📋 Checkbox #${index}: "${originalValue}" → compatible: ${isCompatible}`);
      }

      if (isCompatible) {
        listItem.style.display = '';
        listItem.classList.remove('hidden');
        shown++;
      } else {
        listItem.style.display = 'none';
        listItem.classList.add('hidden');
        hidden++;
        if (checkbox.checked) checkbox.checked = false;
      }
    });

    // 2. Filtra elementi <li> modello (filtri home)
    const modelListItems = document.querySelectorAll('.filter-select__item[data-filter*="filtro_modello"]');
    console.log(`🔍 Trovati ${modelListItems.length} elementi lista modello`);

    modelListItems.forEach((item, index) => {
      const dataFilter = item.getAttribute('data-filter');
      if (!dataFilter) return;

      const match = dataFilter.match(/filtro_modello=([^&]+)/);
      if (!match) return;

      const modelValue = decodeURIComponent(match[1]).toLowerCase().trim();
      const isCompatible = compatibleModels.has(modelValue);

      if (index < 3) {
        console.log(`📋 ListItem #${index}: "${modelValue}" → compatible: ${isCompatible}`);
      }

      if (isCompatible) {
        item.style.display = '';
        item.classList.remove('hidden');
        shown++;
      } else {
        item.style.display = 'none';
        item.classList.add('hidden');
        hidden++;
      }
    });

    console.log(`✓ Mostrati: ${shown}, Nascosti: ${hidden}`);
  }

  showAllModels() {
    // Mostra tutti i modelli quando nessuna marca è selezionata

    // 1. Mostra checkbox modello (filtri collezione)
    const modelCheckboxes = document.querySelectorAll('input[type="checkbox"][data-filter*="filtro_modello"]');
    modelCheckboxes.forEach(checkbox => {
      const listItem = checkbox.closest('li');
      if (listItem) {
        listItem.style.display = '';
        listItem.classList.remove('hidden');
      }
    });

    // 2. Mostra elementi lista modello (filtri home)
    const modelListItems = document.querySelectorAll('.filter-select__item[data-filter*="filtro_modello"]');
    modelListItems.forEach(item => {
      item.style.display = '';
      item.classList.remove('hidden');
    });
  }

  attachListeners() {
    // 1. Ascolta cambiamenti sui checkbox (filtri collezione)
    document.addEventListener('change', (e) => {
      if (e.target.type === 'checkbox') {
        const dataFilter = e.target.getAttribute('data-filter');

        // Se è un checkbox marca, riapplica i filtri
        if (dataFilter && dataFilter.includes('filter_marca')) {
          console.log('Marca cambiata, riapplico filtri...');
          setTimeout(() => this.setupFilters(), 100);
        }
      }
    });

    // 2. Ascolta click su elementi marca (filtri home)
    document.addEventListener('click', (e) => {
      const brandItem = e.target.closest('.filter-select__item[data-filter*="filter_marca"]');
      if (brandItem && !brandItem.classList.contains('holder')) {
        // Toggle classe selected
        brandItem.classList.toggle('selected');
        console.log('🖱️ Marca selezionata/deselezionata, riapplico filtri...');
        setTimeout(() => this.setupFilters(), 50);
      }
    });

    // Ascolta l'evento di aggiornamento dei facets (quando Shopify ricarica i filtri via AJAX)
    document.addEventListener('facets:updated', () => {
      console.log('Facets aggiornati, riapplico filtri...');
      setTimeout(() => this.setupFilters(), 200);
    });

    // Osserva quando vengono AGGIUNTI nuovi nodi (non modificati gli stili)
    let observerTimeout;
    const observer = new MutationObserver((mutations) => {
      // Controlla se sono stati aggiunti nuovi checkbox modello
      const hasNewCheckboxes = mutations.some(mutation =>
        mutation.addedNodes.length > 0 ||
        (mutation.type === 'attributes' && mutation.attributeName === 'aria-hidden')
      );

      if (hasNewCheckboxes) {
        clearTimeout(observerTimeout);
        observerTimeout = setTimeout(() => {
          console.log('🔄 DOM cambiato, riapplico filtri...');
          this.setupFilters();
        }, 150);
      }
    });

    // Osserva tutto il body per nuovi elementi
    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['aria-hidden', 'open']
    });

    // Riapplica filtri quando si clicca su pulsanti/summary dei filtri
    document.addEventListener('click', (e) => {
      const target = e.target.closest('summary, button, [role="button"], .facet-filters__summary');
      if (target) {
        setTimeout(() => {
          console.log('🖱️ Click su controllo, riapplico filtri...');
          this.setupFilters();
        }, 150);
      }
    });

    console.log('✓ Listeners e observer attivati');
  }
}

// Inizializza quando il DOM è pronto
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new CascadeFilters();
  });
} else {
  new CascadeFilters();
}